/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Serializer to represent `DataPoint` information.
 * @export
 * @interface SimpleDataPointRequest
 */
export interface SimpleDataPointRequest {
    /**
     * 
     * @type {string}
     * @memberof SimpleDataPointRequest
     */
    dataBatch: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleDataPointRequest
     */
    plumeImage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleDataPointRequest
     */
    emissionDetected?: boolean;
    /**
     * Rate of emission detected (g/hr)
     * @type {number}
     * @memberof SimpleDataPointRequest
     */
    detectedRate?: number | null;
    /**
     * Uncertainty of emission detected rate (g/hr)
     * @type {number}
     * @memberof SimpleDataPointRequest
     */
    detectedRateUncertainty?: number | null;
    /**
     * Detection limit (g/hr)
     * @type {number}
     * @memberof SimpleDataPointRequest
     */
    detectionLimit: number;
    /**
     * Concentration of the emission (ppm)
     * @type {number}
     * @memberof SimpleDataPointRequest
     */
    concentration?: number | null;
    /**
     * Uncertainty of emission concentration value (ppm)
     * @type {number}
     * @memberof SimpleDataPointRequest
     */
    concentrationUncertainty?: number | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof SimpleDataPointRequest
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {any}
     * @memberof SimpleDataPointRequest
     */
    data?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof SimpleDataPointRequest
     */
    detectionTimestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof SimpleDataPointRequest
     */
    secondaryDataSource?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleDataPointRequest
     */
    version?: string;
}

/**
 * Check if a given object implements the SimpleDataPointRequest interface.
 */
export function instanceOfSimpleDataPointRequest(value: object): value is SimpleDataPointRequest {
    if ((!('dataBatch' in (value as Record<string, any>)) && !('data_batch' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataBatch'] === undefined && (value as Record<string, any>)['data_batch'] === undefined)) return false;
    if ((!('detectionLimit' in (value as Record<string, any>)) && !('detection_limit' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionLimit'] === undefined && (value as Record<string, any>)['detection_limit'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('detectionTimestamp' in (value as Record<string, any>)) && !('detection_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionTimestamp'] === undefined && (value as Record<string, any>)['detection_timestamp'] === undefined)) return false;
    return true;
}

export function SimpleDataPointRequestFromJSON(json: any): SimpleDataPointRequest {
    return SimpleDataPointRequestFromJSONTyped(json, false);
}

export function SimpleDataPointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleDataPointRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dataBatch': json['data_batch'],
        'plumeImage': json['plume_image'] === undefined ? undefined : json['plume_image'] === null ? null : json['plume_image'],
        'emissionDetected': json['emission_detected'] == null ? undefined : json['emission_detected'],
        'detectedRate': json['detected_rate'] === undefined ? undefined : json['detected_rate'] === null ? null : json['detected_rate'],
        'detectedRateUncertainty': json['detected_rate_uncertainty'] === undefined ? undefined : json['detected_rate_uncertainty'] === null ? null : json['detected_rate_uncertainty'],
        'detectionLimit': json['detection_limit'],
        'concentration': json['concentration'] === undefined ? undefined : json['concentration'] === null ? null : json['concentration'],
        'concentrationUncertainty': json['concentration_uncertainty'] === undefined ? undefined : json['concentration_uncertainty'] === null ? null : json['concentration_uncertainty'],
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'data': json['data'] === undefined ? undefined : json['data'] === null ? null : json['data'],
        'detectionTimestamp': (new Date(json['detection_timestamp'])),
        'secondaryDataSource': json['secondary_data_source'] == null ? undefined : json['secondary_data_source'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function SimpleDataPointRequestToJSON(json: any): SimpleDataPointRequest {
    return SimpleDataPointRequestToJSONTyped(json, false);
}

export function SimpleDataPointRequestToJSONTyped(value?: SimpleDataPointRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_batch': value['dataBatch'],
        'plume_image': value['plumeImage'],
        'emission_detected': value['emissionDetected'],
        'detected_rate': value['detectedRate'],
        'detected_rate_uncertainty': value['detectedRateUncertainty'],
        'detection_limit': value['detectionLimit'],
        'concentration': value['concentration'],
        'concentration_uncertainty': value['concentrationUncertainty'],
        'location': DataPointHistoryLocationToJSON(value['location']),
        'data': value['data'],
        'detection_timestamp': value['detectionTimestamp'].toISOString(),
        'secondary_data_source': value['secondaryDataSource'],
        'version': value['version'],
    };
}

